export const getFileNameFromRaw = raw => {
  let fileName = raw.name.split('.');
  let extension = fileName.pop();
  fileName =
    fileName.join('_').replace(/[^a-zA-Z0-9-_]/g, '_') + `.${extension}`;

  return fileName;
};
